// extracted by mini-css-extract-plugin
export default {"item":"Item_item","text":"Item_text"};